import React from 'react';
import { article } from '../../advice/styles';
import { MainLayout } from '../../main-layout';
import { useSelector } from 'react-redux';
import { getSeoH1 } from 'features/page-model/ducks/get-model';
import { CommonDescription } from './common-description';
import { SplitDescription } from './split-description';

export const MasterKredit = () => {
  const h1 = useSelector(getSeoH1);

  return (
    <MainLayout>
      <div className={article}>
        <div className="container service-page">
          <section>
            <div className="row">
              <div className="header">
                <h1>{h1}</h1>
              </div>
            </div>
            <div className="row">
              <div className="service-content">
                <div className="service-section section">
                  <div
                    className="service-section-comp"
                    id="service_section"
                    data-navtitle="ОБЩАЯ ИНФОРМАЦИЯ">
                    <div className="par service-section-parsys parsys">
                      <div className="adaptiveImage parbase section">
                        <img
                          src="https://cdn.lemanapro.ru/lmru/image/upload/v1530793836/fudzi/elbrus/images/servicebigicon/desctop/kredit_d.svg/kredit_d.svg"
                          data-desktopref="https://cdn.lemanapro.ru/lmru/image/upload/v1530793836/fudzi/elbrus/images/servicebigicon/desctop/kredit_d.svg/kredit_d.svg"
                          data-tabletref="https://cdn.lemanapro.ru/lmru/image/upload/v1530793837/fudzi/elbrus/images/servicebigicon/tablet/credit tab.svg/credit tab.svg"
                          data-mobileref="https://cdn.lemanapro.ru/lmru/image/upload/v1527940658/fudzi/elbrus/credit mob.svg/credit mob.svg"
                          className="resize-image"
                        />
                      </div>
                      <div className="store-selector section">
                        <div className="store-selector-all-stores">
                          <span className="lm icon-circle-info store-selector-info"></span>
                          <span className="store-selector-text">
                            Информация по кредитам и кредитам без переплат
                          </span>
                        </div>
                      </div>
                      <div className="text parbase section">
                        <CommonDescription />
                        <p>&nbsp;</p>
                        <p>
                          <span className="rte-standard">
                            <b>КРЕДИТ БЕЗ ПЕРЕПЛАТ*</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Во всех магазинах Лемана ПРО при соблюдении условий кредитования
                            действует программа «Кредит без переплат» на все товары из отделов «Кухни»,
                            «Хранение», «Электротовары», «Водоснабжение», на проекты «Ванная комната»,
                            «Входные/межкомнатные двери», а также проекты «Напольные покрытия» и «Плитка».
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>&nbsp;</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>С нами выгодно!</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">
                                  Диапазон значений полной стоимости кредита/займа от 24,9% до 25,67%
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Кредит/заём без переплат на срок 6 или 10 месяцев
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Сумма кредита/займа от 2&nbsp;000 рублей*** до 1&nbsp;000&nbsp;000 рублей
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Переплата — 0%</span>
                              </li>
                              <li>
                                <span className="rte-standard">Первоначальный взнос — 0%</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>На что предоставляется «Кредит без переплат»</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">1. Все товары отдела «Кухни»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">На сумму от 80&nbsp;000 рублей</span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок кредита: 6, 10 месяцев.</span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">2. Все товары отдела «Хранение»</span>
                        </p>

                        <ul>
                          <li>
                            <span className="rte-standard">На сумму от 50&nbsp;000 рублей</span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок кредита: 6, 10 месяцев.</span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">3. Проекты отдела «Напольные покрытия»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              Проект «Линолеум», который включает в себя: линолеум, клей для линолеума
                              (универсальный, контактный, фиксатор), плинтус, аксессуары для плинтуса.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Проект «ПВХ-плитка клеевая», который включает в себя: ПВХ-плитка клеевая, клей
                              для ПВХ-плитки (контактный, фиксатор), плинтус, аксессуары для плинтуса.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Проект «ПВХ-плитка замковая», который включает в себя: ПВХ-плитка замковая,
                              плинтус, аксессуары для плинтуса.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Проект «Паркет», который включает в себя: паркетная доска, подложка/клей для
                              паркета, плинтус, аксессуары для плинтуса.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Проект «Массив», который включает в себя: массивная доска, клей для паркета,
                              плинтус, аксессуары для плинтуса.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Проект «Ламинат», включает в себя: ламинат, подложка для ламината, плинтус, аксессуары для плинтуса.
                            </span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-small">
                            Важно: товары «Лучшая цена» оформить по программе «Кредит без переплат» нельзя
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">Срок кредита: 6 месяцев.</span>
                          </li>
                        </ul>
                        
                        <p>
                          <span className="rte-standard">4. Проект «Ванная комната»</span>
                        </p>
                        <ul>
                          <li>
                            <span>
                              <span className="rte-standard">
                                Проект «Плитка + сантехника» через конфигуратор или самостоятельно собранный
                                клиентом (плитка + тяжёлая сантехника) на сумму от 90&nbsp;000 рублей.
                                Тяжёлая сантехника: ванна/душевая кабина/ширма, унитазы, инсталляции.
                              </span>
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Проект «Сантехника»: минимум 2 товара (мебель + ванна/ширма/душевая кабина;
                              мебель + унитаз; унитаз + ванна/ширма/душевая кабина; 2 товара из разных
                              категорий тяжёлой сантехники; тяжёлая сантехника: ванна/ширма/душевая кабина,
                              унитазы, инсталляции) при покупках на сумму от 50&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Кредит без переплат предоставляется только на Проекты, перечисленные выше.
                              На отдельные товары отделов «Сантехника» не предоставляется, даже, если их стоимость больше 50&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок кредита: 6, 10 месяцев.</span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">5. Проект «Входные/межкомнатные двери»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              В проект «Межкомнатные двери» обязательно входят дверные полотна + коробка
                              (количество полотен равно количеству коробок) и по желанию комплектующие к ним
                              (наличники, доборы, ручки, петли, замки, стопоры, защёлки) при покупках на
                              сумму от 35&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              В проект «Входные двери» входят входные двери стоимостью от 22&nbsp;000 рублей
                              за одну дверь.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Без дверного полотна кредит без переплат на комплектующие к межкомнатным и входным дверям не предоставляется.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Дверное полотно без коробки оформить нельзя.
                            </span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-small">
                            Товары «Лучшая цена» оформить по программе «Кредит без переплат» нельзя.
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">Срок кредита без переплат: 6,10 месяцев.</span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">6. Товары отдела «Электротовары»</span>
                        </p>
                        <p>
                          <span className="rte-standard">На все товары отдела «Электротовары»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">При покупке на сумму от 35&nbsp;000 рублей.</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              В заказ должны быть включены только товары отдела «Электротовары».
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок кредита: 6 месяцев.</span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">На сплит-системы (кондиционеры)</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              При условии заказа услуги установки. Услуга может быть оплачена наличными
                              денежными средствами, банковской картой или оформлена в кредит. Важно: оформить
                              услуги по программе «Кредит без переплат» нельзя.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              На все кондиционеры, независимо от количества и стоимости (кроме брендов Monlan
                              и Komanchi).
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок кредита: 6 месяцев.</span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">7. Товары отдела «Водоснабжение»</span>
                        </p>
                        <p>
                          <span className="rte-standard">На все товары отдела</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">При покупке на сумму от 35&nbsp;000 рублей.</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              В заказ должны быть включены только товары отдела «Водоснабжение».
                            </span>
                          </li>
                          <li>
                            <span>
                              <span className="rte-standard">Срок кредита: 6 месяцев.</span>
                            </span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">
                            На трубчатые радиаторы Irsap Tesi и Rifar Tubog
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">Нет ограничений по количеству и стоимости.</span>
                          </li>
                          <li>
                            <span>
                              <span className="rte-standard">Срок кредита: 6 месяцев.</span>
                            </span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">8. Проект отдела «Плитка»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              Проект «Плитка», который включает в себя плитку и клей для плитки. В проект
                              можно включить сопутствующие товары отдела: затирку, крестики, уголки.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Товары ЛЦ оформить по Программе «Кредит без переплат» нельзя.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              При покупке на сумму от от 50&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок кредита: 6, 10 месяцев.</span>
                          </li>
                        </ul>
                        <p>
                          <span className="rte-standard">9. Проект «Терраса и ограждение»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              Кредит без переплат можно оформить на проекты: «Терраса», «Ограждение», «Терраса и ограждение»;
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Кредит предоставляется на террасную доску (ДПК, дерево), брус, доски, ограждения, ступени, перила, балясины,
                              столбы, опоры, лаги, крепеж, аксессуары для ограждений и досок;
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Кредит предоставляется на сумму от 60&nbsp;000 рублей;
                            </span>
                          </li>
                          
                          <li>
                            <span className="rte-standard">Срок: 6 месяцев.</span>
                          </li>
                        </ul>
                        <p>&nbsp;</p>
                          <p>
                            <span className="rte-standard">
                              <b>КРЕДИТ НА БОЛЬЩИЕ ЦЕЛИ ПО НИЗКОЙ СТАВКЕ **</b>
                            </span>
                          </p>
                          <p>
                          <span className="rte-standard">
                            Во всех магазинах Лемана ПРО при соблюдении условий кредитования
                            действует программа «Кредит на большие цели по низкой ставке» на все товары из отделов «Кухни»,
                            «Хранение», на проекты «Ванная комната», «Входные/межкомнатные двери», «Плитка».
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">Диапазон значений полной стоимости кредита/займа от 24,9% до 25,67%</span>
                          </li>
                          <li>
                            <span className="rte-standard">Предоставляемые сроки продукта «Кредит на большие цели по низкой ставке» — 12, 18 или 24 месяца</span>
                          </li>
                          <li>
                            <span className="rte-standard">Сумма кредита/займа от 2&nbsp;000 рублей*** до 1&nbsp;000&nbsp;000 рублей</span>
                          </li>
                          <li>
                            <span className="rte-standard">Переплата — 1,6% при оформлении кредита на 12 месяцев, 7,27% при оформлении кредита на 18 месяцев и на 13,13% при оформлении кредита на 24 месяца.</span>
                          </li>
                          <li>
                            <span className="rte-standard">Первоначальный взнос — 0%</span>
                          </li>

                          </ul>

                          <p>
                          <span className="rte-standard">
                            <b>На что предоставляется «Кредит на большие цели по низкой ставке»</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">1. Все товары отдела «Кухни»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">На сумму от 80&nbsp;000 рублей.</span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок: 12,18 и 24 месяца.</span>
                          </li>
                        </ul>

                        <p>
                          <span className="rte-standard">2. Все товары отдела «Хранение»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">На сумму от 50&nbsp;000 рублей</span>
                          </li>
                          <li>
                            <span className="rte-standard">Срок: 12,18 и 24 месяца.</span>
                          </li>
                        </ul>
                        
                        <p>
                          <span className="rte-standard">3. Проект «Ванная комната»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                            Проект «Плитка + сантехника» через конфигуратор или самостоятельно собранный
                            клиентом (плитка + тяжёлая сантехника) на сумму от 90&nbsp;000 рублей. Тяжёлая сантехника: ванна/душевая кабина/ширма, унитазы, инсталляции.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Проект «Сантехника»: минимум 2 товара (мебель + ванна/ширма/душевая кабина;
                              мебель + унитаз; унитаз + ванна/ширма/душевая кабина; 2 товара из разных категорий тяжёлой сантехники;
                              тяжёлая сантехника: ванна/ширма/душевая кабина, унитазы, инсталляции) при покупках на сумму от 50&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Кредит без переплат предоставляется только на Проекты, перечисленные выше. На отдельные товары отделов «Сантехника» не предоставляется, даже, если их стоимость больше 50&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              Срок: 12, 18 и 24 месяца.
                            </span>
                          </li>
                        </ul>

                        <p>
                          <span className="rte-standard">4. Проект «Входные/межкомнатные двери»</span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                            В проект «Межкомнатные двери» обязательно входят дверные полотна + коробка (количество полотен равно количеству коробок) и по желанию комплектующие к ним (наличники, доборы, ручки, петли, замки, стопоры, защёлки) при покупках на сумму от 35&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              В проект «Входные двери» входят входные двери стоимостью от 22&nbsp;000 рублей за одну дверь.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                            Без дверного полотна кредит без переплат на комплектующие к межкомнатным и входным дверям не предоставляется;
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                            Дверное полотно без коробки оформить нельзя.
                            </span>
                          </li>
                          </ul>
                        <p>
                          <span className="rte-small">
                          Товары «Лучшая цена» оформить по программе «Кредит на большие цели по низкой ставке» нельзя.
                          </span>
                        </p>
                          <ul>
                          <li>
                            <span className="rte-standard">
                              Срок: 12,18 и 24 месяца.
                            </span>
                          </li>
                        </ul>

                        <p>
                          <span className="rte-standard">
                            5. Проект отдела «Плитка»
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                            Проект «Плитка», который включает в себя плитку и клей для плитки. В проект можно включить сопутствующие товары отдела: затирку, крестики, уголки.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                            Товары ЛЦ оформить по Программе «Кредит без переплат» нельзя.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                            При покупке на сумму от от 50&nbsp;000 рублей.
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                            Срок: 12,18 и 24 месяца.
                            </span>
                          </li>
                        </ul>

                        <p>&nbsp;</p>
                        <p>
                          <b>* Кредит/заём без переплат.</b>
                        </p>
                        <p>
                        Кухня, Ванная комната, Входные и межкомнатные двери, Товары для хранения, Напольные покрытия,
                        Электротовары, Товары для водоснабжения и отопления. 
                        </p>
                        <p>
                        «Кредиты/ займы без переплат»* предоставляют: АО «Кредит Европа Банк (Россия)», универсальная лицензия
                        ЦБ РФ на осуществление банковских операций № 3311 от 03.09.2019 г.; КБ «Ренессанс Кредит» (ООО),
                        лицензия Банка России на осуществление банковских операций № 3354 от 26.04.2013 г.; АО «ОТП Банк»,
                        лицензия на осуществление банковских операций № 2766 от 27.11.2014 г.; Регистрационный номер записи в государственном
                        реестре микрофинансовых организаций №651503045006297 от 16.02.2015 г; АО «Банк Русский Стандарт» лицензия ЦБ РФ № 2289 от 04.09.2024.
                        </p>
                        <p>
                          В рамках акции «Кредит/ заем без переплат» по итогам проверки заёмщика: диапазон значений полной стоимости кредита/ займа от 24,9% до 25,67%,
                          процентная ставка по кредиту/ займу составляет: при установлении нескольких ставок для разных периодов срока кредита/ займа - от 24,9% до 25,67%
                          (для кредитов в АО «Кредит Европа Банк (Россия); от 24,9% до 25% (для кредитов в КБ «Ренессанс Кредит» (ООО), АО «ОТП Банк»), срок кредита/ займа
                          от 6 месяцев до 10 месяцев, сумма кредита/ займа от 2 тыс. 500 рублей до 500 тыс. рублей (для кредитов в АО «Кредит Европа Банк (Россия)»;
                          срок кредита/ займа 6, 10 месяцев сумма кредита/ займа от 5 тыс.  рублей до 1 млн.. рублей (для кредитов в КБ «Ренессанс Кредит» (ООО);
                          срок кредита/ займа 6, 10 месяев сумма кредита/ займа  2 тыс. руб. до 300 тыс. рублей (для кредитов АО «ОТП Банк»,); при установлении нескольких ставок для разных периодов срока кредита/ займа – от 25% до 25%, срок кредита 6,10 месяцев,
                          сумма кредита от 3 тыс. рублей до 299 тыс. рублей (для АО «Банк Русский Стандарт»);
                        </p>
                        <p>
                          Погашение задолженности осуществляется ежемесячными платежами, исходя из срока предоставленного кредита/ займа в соответствии с условиями договора
                          кредита/ займа.
                        </p>
                        <p>
                          * Кредит/ заем без переплат означает, что при приобретении товара с использованием кредитных/ заемных средств указанных банков-партнеров/МФК
                          OOО «ЛЕ МОНЛИД» (ИНН5029069967) предоставляет покупателю скидку на приобретаемый товар от 7.0% до 9,8%, в результате чего сумма
                          кредита/ займа, выплачиваемая покупателем банку-партнеру/МФК с учетом суммы процентов, не превышает первоначальной стоимости товара,
                          при условии, что погашение кредита/ займа осуществляется покупателем в соответствии с графиком платежей, без просрочек, дополнительные услуги
                          банков-партнеров/МФК не приобретаются. Специальное предложение по оплате товаров за счет кредитных/ заемных средств, предоставляемых
                          банками-партнерами/МФК, распространяется на товары из отделов: Ванная комната (отделы Сантехника и Плитка), Кухни, Хранение, Напольные покрытия,
                          Входные/межкомнатные двери (отдел Столярные изделия), Электротовары, Водоснабжение. Подробные условия можно уточнить у продавцов-консультантов и
                          в кредитном отделе.
                        </p>
                        <p>
                          Правила и условия предоставления кредитов/займов Банками-партнерами в местах оформления кредита/ займа или на сайтах Банков-партнеров www.crediteurope.ru,
                          www.rencredit.ru, www.otpbank.ru, www.otpfinance.ru
                        </p>
                        <p>
                          Банк имеет право отказать клиенту в предоставлении кредита/ займа без объяснения причин отказа. Информация не является офертой.
                        </p>
                      </div>
                      <p>&nbsp;</p>
                        <p>
                          <b>** Кредит на большие цели по низкой ставке.</b>
                        </p>
                        <p>
                          Кухня, Ванная комната, Входные и межкомнатные двери, Товары для хранения.
                        </p>
                        <p>
                          «Кредит на большие цели по низкой ставке»* предоставляют: АО «Кредит Европа Банк (Россия)», универсальная лицензия ЦБ РФ на осуществление банковских операций № 3311 от 03.09.2019 г.; КБ «Ренессанс Кредит» (ООО), лицензия Банка России на осуществление банковских операций № 3354 от 26.04.2013 г.; АО «ОТП Банк», лицензия на осуществление банковских операций № 2766 от 27.11.2014 г.; АО «Банк Русский Стандарт» лицензия ЦБ РФ № 2289 от 04.09.2024 
                        </p>
                        <p>
                          В рамках акции «Кредит на большие цели по низкой ставке» по итогам проверки
                          заёмщика: диапазон значений полной стоимости кредита/ займа от 24,9% до 25,67%,
                          процентная ставка по кредиту/ займу составляет: при установлении нескольких ставок
                          для разных периодов срока кредита/ займа - от 25,19% до 25,67% (для кредитов в АО «Кредит Европа Банк (Россия);
                          от 24.9% до 25% (для кредитов в КБ «Ренессанс Кредит» (ООО), АО «ОТП Банк), срок кредита/ займа от 12,18,24 месяцев,
                          сумма кредита/ займа от 2 тыс. 500 рублей до 500 тыс. рублей (для кредитов в АО «Кредит Европа Банк (Россия); срок кредита/ займа
                          от 12,18,24 мес. сумма кредита/ займа от 5 тыс. рублей до 1 млн. рублей (для кредитов в КБ «Ренессанс Кредит» (ООО); 
                          срок кредита/ займа от 12,18,24 месяцев, сумма кредита/ займа от 2 тыс. рублей до 300 тыс. рублей АО «ОТП Банк»); при установлении нескольких ставок для разных периодов срока кредита/ займа – от 25% до 25%, срок кредита 12,18,24 месяцев, сумма кредита от 3 тыс.
                          рублей до 299 тыс. рублей (для АО «Банк Русский Стандарт»).
                        </p>
                        <p>
                          Погашение задолженности осуществляется ежемесячными платежами, исходя из срока предоставленного кредита/ займа в соответствии с условиями договора кредита/ займа.
                        </p>
                        <p>
                          * «Кредит на большие цели по низкой ставке» означает, что при приобретении товара с использованием
                          кредитных/ заемных средств указанных банков-партнеров/МФК OOО «ЛЕ МОНЛИД» (ИНН5029069967) предоставляет
                          покупателю скидку на приобретаемый товар в размере 10,0%, в результате чего сумма кредита/займа, выплачиваемая
                          покупателем банку-партнеру/МФК с учетом суммы процентов, превышает первоначальную стоимость товара на 1,6% при
                          оформлении кредита на 12 месяцев, на 7,27% при оформлении кредита на 18 месяцев и на 13,13% при оформлении кредита
                          на 24 месяца. При условии, что погашение кредита/ займа осуществляется покупателем в соответствии с графиком
                          платежей, без просрочек, дополнительные услуги банков-партнеров/МФК не приобретаются. Специальное предложение
                          по оплате товаров за счет кредитных/ заемных средств, предоставляемых банками-партнерами/МФК, распространяется
                          на товары из отделов: Ванная комната (отделы Сантехника и Плитка), Кухни, Хранение, Входные/межкомнатные двери
                          (отдел Столярные изделия). Подробные условия можно уточнить у продавцов-консультантов и в кредитном отделе.
                        </p>
                        <p>
                          Правила и условия предоставления кредитов/займов Банками-партнерами в местах оформления кредита/ займа или на сайтах
                          Банков-партнеров www.crediteurope.ru, www.rencredit.ru, www.otpbank.ru, https://www.homecredit.ru, www.otpfinance.ru
                        </p>
                        <p>
                          Банк имеет право отказать клиенту в предоставлении кредита/ займа без объяснения причин отказа. Информация не является офертой.
                          </p>
                        <p></p>


                      <p>&nbsp;</p>
                      <div className="text parbase section">
                        <p>
                          <span className="rte-standard">
                            <b>Кредит на покупку товаров в Лемана ПРО**</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Во всех магазинах Лемана ПРО доступны кредитные программы
                            банков-партнёров/МФО на весь ассортимент товаров.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>&nbsp;</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>Выберите выгодное условия для покупок</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">
                                  Диапазон значений полной стоимости кредита от 24,9% до 29,9%
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Кредит/заём на срок 6-60 месяцев</span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Сумма кредита/займа от 2&nbsp;000 рублей до 1&nbsp;000&nbsp;000 рублей
                                  (точную сумму уточняйте у кредитного специалиста в магазине, минимальная
                                  сумма зависит от выбранного банка)
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Первоначальный взнос от 0%.</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>Необходимые документы</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">Паспорт гражданина РФ</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>Требования к заёмщику</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">Гражданство Российской Федерации</span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Постоянная регистрация на территории Российской Федерации
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Постоянное место работы</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>&nbsp;</p>
                        <p><b>*** Кредит</b></p>
                        <p>
                          Кредит /заем на покупку товаров в Лемана ПРО предоставляют: АО «Кредит Европа Банк (Россия)», универсальная лицензия ЦБ РФ на осуществление
                          банковских операций № 3311 от 03.09.2019 г.; КБ «Ренессанс Кредит» (ООО), лицензия Банка России на осуществление банковских операций № 3354 от 26.04.2013 г.;
                          АО «ОТП Банк», лицензия на осуществление банковских операций № 2766 от 27.11.2014 г.; АО «Банк Русский Стандарт» лицензия ЦБ РФ № 2289 от 04.09.2024; ООО МФК «ДК ПЭЙ», свидетельство о внесении сведений о юридическом лице в государственный реестр микрофинансовых организаций от 27.12.2023.
                        </p>
                        <p>
                          В рамках акции «Кредит/ заем на покупку товаров в Лемана ПРО» по итогам проверки заёмщика: диапазон значений полной стоимости кредита от 24,0% до 26,8%
                          (для кредитов АО «Кредит Европа Банк (Россия)»); 25% (для кредитов в КБ «Ренессанс Кредит» (ООО), 29,0%-34,0%т АО «ОТП Банк»; 30% для ООО МФК «ДК ПЭЙ; срок кредита/ займа от 6-36 месяцев,
                          сумма кредита/ займа от 2 тыс. 500 рублей до 750 тыс. рублей (для кредитов в АО «Кредит Европа Банк (Россия); срок кредита/ займа от 6-24 месяцев,
                          сумма кредита/ займа от 5 тыс. рублей до 1 млн. рублей (для кредитов в КБ «Ренессанс Кредит» (ООО); срок кредита/ займа от 6-12 месяцев, сумма кредита/ займа от 5 тыс. рублей до 200 тыс. рублей (для кредитов ООО МФК «ДК ПЭЙ); срок кредита/ займа от 6-36 месяцев, сумма кредита/ займа
                          от 2 тыс. рублей до 300 тыс. рублей АО «ОТП Банк»); при установлении нескольких ставок для разных периодов срока кредита/ займа – от 29% до 29%,
                          срок кредита 6-36 месяцев, сумма кредита от 3 тыс. рублей до 299 тыс. рублей (для АО «Банк Русский Стандарт»).
                        </p>
                        <p>
                          Погашение задолженности осуществляется ежемесячными платежами, исходя из срока предоставленного кредита/ займа в соответствии с условиями договора кредита/ займа.
                        </p>
                        <p>
                          Кредит/заем предоставляется на весь ассортимент товаров Лемана ПРО. Правила покупки в кредит/ заем в местах оформления кредита/ займа или на сайтах
                          банков www.crediteurope.ru, www.rencredit.ru, www.otpbank.ru, www.otpfinance.ru
                        </p>
                        <p>
                           Банк имеет право отказать клиенту в предоставлении кредита/ займа без объяснения причин отказа.
                        </p>
                      </div>
                      <p>&nbsp;</p>
                      <div className="text parbase section">
                        <p>
                          <span className="rte-standard">
                            <b>Способы погашения кредита/займа</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Каналы погашения <b>без комиссии</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">
                                  Перевод по номеру телефона через систему быстрых платежей (СБП)
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Перевод денег через отделения почтовой связи АО «Почта России» почтовым
                                  отправлением
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Каналы погашения банков-партнёров****
                                </span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>Важно:</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            1. <b>ОЦЕНИВАЙТЕ СВОИ ФИНАНСОВЫЕ ВОЗМОЖНОСТИ И РИСКИ</b>.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            2. Кредит/заём можно <b>погасить</b> частично или полностью <b>досрочно</b>: в
                            любой момент в течение срока кредитного договора/договора займа, без
                            дополнительных комиссий.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            3. Товар, приобретённый в кредит/заём, можно <b>вернуть</b> в соответствии с
                            условиями <a href="/service/vozvrat-tovara/">возврата</a> и обмена товара.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            4. За рассмотрение заявления на кредит/заём и выдачу кредита/займа{' '}
                            <b>комиссия не взимается</b>.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            5. В выбранных магазинах Лемана ПРО можно оформить кредит/заём на
                            товар и услугу по его <b>установке и доставке</b>.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            6. Предложение по кредитам действует только при покупке товаров в магазинах
                            Лемана ПРО.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            7. Предложение не действует при заказе товаров через{' '}
                            <a href="/">интернет-магазин Лемана ПРО</a> и мобильное приложение
                            Лемана ПРО.
                          </span>
                        </p>
                        <p>&nbsp;</p>
                        <p>
                          <span className="rte-standard">
                            Банк/МФО имеет право отказать клиенту в предоставлении кредита/займа без
                            объяснения причин отказа. Информация не является офертой.
                          </span>
                        </p>
                        <p>
                          **** С информацией о каналах погашения кредитов/займов банков/МФО-партнёров вы
                          сможете ознакомиться в магазинах Лемана ПРО в кредитном отделе и на
                          сайтах банков или МФО-партнёров.
                        </p>
                        <p>
                          ***** Информацию по возможности оформления услуг в кредит/заём уточняйте в вашем
                          магазине.
                        </p>
                        <p>
                          Информация по кредитным продуктам, указанная на данной странице, предоставлена: ООО
                          «Кредит консалтинг» (ОГРН 1077760014111, ИНН 7733621690), ООО «Кредитные Системы»
                          (ОГРН 1167746335833, ИНН 7719443075), ООО «Директ Кредит Центр» (ОГРН 1157746356690, ИНН 7701327127) которые отвечают за формирование и сопровождение
                          указанных кредитных программ по заказу ООО «ЛЕ МОНЛИД», в соответствии с договорами на брокерское обслуживание.
                        </p>
                      </div>
                      <SplitDescription />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </MainLayout>
  );
};
